import { useState, useEffect } from "react";

const heroImages = [
  // "/images/carousel1.jpeg",
  // "/images/carousel2.jpg",
  "/images/Building1.png",
];

const HeroSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % heroImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-[90vh] w-full overflow-hidden bg-gradient-to-br from-gray-900 via-red-900 to-red-800">
      
      {/* Background Images */}
      {heroImages.map((img, index) => (
        <div
          key={img}
          className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
            index === activeIndex ? "opacity-100" : "opacity-0"
          }`}
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />

      {/* Content */}
      <div className="relative z-10 flex items-center h-full px-6 lg:px-20 py-20">
        <div className="max-w-3xl text-white">
          
          <div className="inline-flex items-center gap-2 bg-red-600/25 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">
              Reliable Power Distribution
            </span>
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light leading-tight mb-4">
            We are <span className="font-bold">Powering Homes</span> and
            <br />
            <span className="font-bold bg-gradient-to-r from-white to-red-200 bg-clip-text text-transparent">
              Empowering Businesses
            </span>
          </h1>

          <p className="mt-4 text-sm sm:text-base md:text-lg text-gray-200 leading-relaxed mb-6">
            BEDC is responsible for retail distribution of electricity in
            Delta, Edo, Ekiti, and Ondo States.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/customer-care"
              className="group animate-pulse hover:animate-none relative overflow-hidden bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-3.5 rounded-xl text-xs sm:text-sm font-semibold text-white transition-all duration-500 hover:shadow-lg hover:shadow-emerald-500/30 active:scale-95 flex items-center justify-center gap-2"
            >
              <span>CUSTOMER CARE</span>
              <span className="group-hover:translate-x-1.5 transition-transform">→</span>
            </a>

            <a
              href="https://newsetup.beninelectric.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 transition-all duration-300 px-6 py-3.5 rounded-xl text-xs sm:text-sm font-semibold flex items-center justify-center gap-2 shadow-lg"
            >
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="relative z-10">CREATE POSTPAID ACCOUNT</span>
              <span className="relative z-10 group-hover:translate-x-1.5 transition-transform">→</span>
            </a>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { value: "7.5K+", label: "MD Customers" },
              { value: "1.6M+", label: "NMD Customers" },
              { value: "192+", label: "Offices" },
              { value: "57K+", label: "Sq Km Coverage" },
            ].map((stat, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-3.5"
              >
                <div className="text-xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-gray-300 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Support Phone Number (Visible on mobile/small screens only) */}
          <div className="flex lg:hidden items-center space-x-3 bg-green-800 px-4 py-2 rounded-full border border-green-600 shadow-inner flex-shrink-0 mt-6 w-fit">
            <div className="leading-tight text-right">
              <p className="text-base tracking-tight">07000002332</p>
              <p className="text-[9px] font-bold opacity-75 uppercase tracking-widest">
                Customer Care
              </p>
            </div>
            <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-green-700 font-bold text-xs">
              ☏
            </div>
          </div>
            
        </div>
      </div>

      {/* Bottom Curve */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden z-20 leading-[0]">
        <svg
          className="relative block w-full h-24"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 100C300 0 1140 0 1440 100H0Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;